import { render, staticRenderFns } from "./RelatedCompanyTab.vue?vue&type=template&id=fb6535be&scoped=true&"
import script from "./RelatedCompanyTab.vue?vue&type=script&lang=js&"
export * from "./RelatedCompanyTab.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCompanyTab.vue?vue&type=style&index=0&id=fb6535be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6535be",
  null
  
)

export default component.exports